import { render, staticRenderFns } from "./memorandumData.vue?vue&type=template&id=12c6c5fe&scoped=true"
import script from "./memorandumData.vue?vue&type=script&lang=js"
export * from "./memorandumData.vue?vue&type=script&lang=js"
import style0 from "./memorandumData.vue?vue&type=style&index=0&id=12c6c5fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c6c5fe",
  null
  
)

export default component.exports